<template>
  <div class="container">
    <div class="title">
      <img src="@/assets/img/img_logo.png" alt="" srcset="">
    </div>
    <div class="div-flex">
      <span>+86</span>
      <input type="text" maxlength="11" placeholder="输入商户入网手机号" v-model="form.mobileNo">
    </div>
    <div class="div-flex">
      <input type="text" v-model="form.smsCode" placeholder="输入短信验证码">
      <div class="valid-code">
        <span v-if="sendCodeBtnStatus" @click="sendCode">获取验证码</span>
        <span class="valid-coded" v-else>重新发送({{time}}s)</span>
      </div>

    </div>
    <div class="div-flex">
      <input type="text" v-model="form.graphCode" placeholder="输入右侧校验码">
      <img class="img-code" slot="right" :src="codeUrl" @click="getCodeUrl">
    </div>
    <md-button class="mt-btn" :inactive="isBtn" type="primary" @click="submit">登 录</md-button>
  </div>
</template>

<script>
import { Field, InputItem, Button, Toast } from "mand-mobile";
import { baseurl } from "@/config/url.js";
import { setHeardTokenId } from "@/utils/http.js";
export default {
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
  },
  created() {
    this.getCodeUrl();
  },
  computed: {
    isBtn() {
      let o = this.form;
      if (o.mobileNo && o.graphCode && o.smsCode) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      codeLoading: false,
      codeUrl: null,
      sendCodeBtnStatus: true,
      time: 90,
      timeObj: null,
      preId:"",
      form: {
        mobileNo: "",
        graphCode: "",
        smsCode: "",
      },
    };
  },
  methods: {
    async sendCode() {
      let mobileNo = this.form.mobileNo;
      if (!/^1\d{10}$/.test(mobileNo))
        return Toast({
          content: "请输入正确的手机号！",
          position: "bottom",
        });
      try {
        this.codeLoading = true;
        await this.$http.post("/h5/send", { mobileNo });
        this.timeObj = setInterval(() => {
          if (this.time == 0) {
            this.time = 90;
            this.sendCodeBtnStatus = true;
            return clearInterval(this.timeObj);
          }
          this.time--;
          this.sendCodeBtnStatus = false;
        }, 1000);
      } finally {
        this.codeLoading = false;
      }
    },
    getCodeUrl() {
      this.preId = new Date().getTime() + "";
      this.codeUrl = baseurl + "/vCode?preId=" + this.preId;
    },
    async submit() {
      let form = this.form;
      form.preId=this.preId;
      if (!/^1\d{10}$/.test(form.mobileNo)) {
        return Toast({
          content: "请输入正确的手机号！",
          position: "bottom",
        });
      }
      if (form.smsCode.length == 0) {
        return Toast({
          content: "请输入验证码！",
          position: "bottom",
        });
      }
      if (form.graphCode.length == 0) {
        return Toast({
          content: "请输入图形码！",
          position: "bottom",
        });
      }
      try {
        let {
          data: { token },
        } = await this.$http.post("/h5/login", form);
        this.$storage.setItem("token", token);
        this.$storage.setItem("loginAccount", form.mobileNo);
        setHeardTokenId(token);
        this.$router.push({
          path: "/list",
        });
      } catch {
        form.graphCode = "";
        this.getCodeUrl();
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 80px 70px 0;
  background: #fff;
}
.title {
  text-align: center;
  margin-bottom: 80px;
  color: #e4cfcf;
  text-shadow: 5px 5px 5px #5394e2;
}
.title img {
  width: 120px;
}
.div-flex {
  display: flex;
  height: 82px;
  align-items: center;
  background: #f6f6f6;
  border-radius: 4px;
  padding-left: 22px;
  font-size: 28px;
  margin-bottom: 56px;
}
.div-flex input:focus {
  outline: none;
}
.div-flex input {
  flex: 1;
  background-color: transparent;
  border: none;
  margin-left: 22px;
  font-size: 28px;
  height: 100%;
}
.img-code {
  height: 100%;
}
.valid-code {
  text-align: center;
  width: 220px;
}
.valid-coded {
  color: #999999;
}
</style>